import tharRed from "../images/cars-big/thar-Red.png";
import tharbrown from "../images/cars-big/thar-brown.png";
import Toyota from "../images/cars-big/toyotacamry.jpg";
import Bmw320 from "../images/cars-big/bmw320.jpg";
import Benz from "../images/cars-big/benz.jpg";
import Passat from "../images/cars-big/passatcc.jpg";

export const CAR_DATA = [
  [
    {
      name: "Thar Roxx",
      price: "2000",
      img: tharRed,
      model: "Thar Roxx 2024",
      mark: "Mahindra",
      year: "2024",
      doors: "5/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "Thar Brown",
      price: "45",
      img: tharbrown,
      model: "Audi",
      mark: "A1",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Manual",
      fuel: "Gasoline",
    },
  ],
  [
    {
      name: "Toyota Camry",
      price: "30",
      img: Toyota,
      model: "Camry",
      mark: "Toyota",
      year: "2006",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Hybrid",
    },
  ],
  [
    {
      name: "BMW 320 ModernLine",
      price: "35",
      img: Bmw320,
      model: "320",
      mark: "BMW",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Manual",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "Mercedes-Benz GLK",
      price: "50",
      img: Benz,
      model: "Benz GLK",
      mark: "Mercedes",
      year: "2006",
      doors: "4/5",
      air: "Yes",
      transmission: "Manual",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "VW Passat CC",
      price: "25",
      img: Passat,
      model: "Passat CC",
      mark: "Volkswagen",
      year: "2008",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Gasoline",
    },
  ],
];
